import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { PanelKey_Home, PanelKey_ProvideInfo } from '../../../_shared.js';
import { ModuleFE_ProvideInfo } from '../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { ICONS } from '@app/styles';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { Component_ProvideInfoHeader } from '../../components/provide-info-v2/header/Component_ProvideInfoHeader/Component_ProvideInfoHeader.js';
import { Component_ProvideInfo_V2 } from '../../components/provide-info-v2/body/Component_ProvideInfoV2/Component_ProvideInfo_V2.js';
import './AdvisorMiniPanel_ProvideInfo.scss';
import { voidFunction } from '@nu-art/ts-common';
export class AdvisorMiniPanel_ProvideInfo extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_ProvideInfo,
        panelType: 'secondary',
    };
    //######################### Life Cycle #########################
    __onProvideInfoContextChange = () => {
        this.setState({
            baseContext: ModuleFE_ProvideInfo.getBaseContext(),
            latestContext: ModuleFE_ProvideInfo.getLatestContext(),
        });
    };
    __onProvideInfoContextUpdate = voidFunction;
    //######################### Logic #########################
    //######################### Render #########################
    renderHeader_Title = () => _jsx(Component_ProvideInfoHeader, { context: this.state.baseContext });
    renderHeader_Tail = () => {
        return _jsx(_Fragment, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: () => ModuleFE_AdvisorMini.openPanel(PanelKey_Home) }) });
    };
    _renderContent(scrollRef) {
        return _jsx(Component_ProvideInfo_V2, { context: this.state.latestContext });
    }
    renderContent = () => _jsx(_Fragment, {});
    renderSubHeader = undefined;
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_ProvideInfo.js.map